import EventBase from '@/model/EventClass/EventBase'
import EventID from '@/model/EventClass/EventID'
import EventNotSelect from '@/model/EventClass/EventNotSelect'

/** docs/ue/事件颜色.md：事件列表前景色（每组取文档中第一个 RGB） */
const C_TEXT = 'rgb(173, 173, 173)'
const C_COMMENT = 'rgb(38, 166, 154)'
const C_AUTO = 'rgb(120, 120, 120)'
const C_LOGIC = 'rgb(101, 131, 193)'
const C_EFFECT = 'rgb(251, 141, 165)'
const C_PIC = 'rgb(251, 135, 228)'
const C_AUDIO = 'rgb(38, 166, 154)'
const C_BOOKMARK = 'rgb(255, 172, 40)'
const C_FALLBACK = '#6ecadc'

const SET_TEXT = new Set<EventID>([
  EventID.AddItem,
  EventID.Text,
  EventID.TextDifEx,
  EventID.TextDifEx2,
  EventID.ValueInput,
  EventID.PromptMessage,
  EventID.TextDif,
  EventID.TextEnd,
  EventID.Loop,
  EventID.LoopBreak,
  EventID.LoopAboveStart,
  EventID.ButtonDif,
  EventID.ButtonDifEnd,
  EventID.Ad,
  EventID.AdEnd,
  EventID.TextChoice,
  EventID.ButtonDifChoose,
  EventID.IfChoice,
  EventID.AdChoice,
])

const SET_AUTO = new Set<EventID>([EventID.AutoPlay, EventID.QuickPlay, EventID.FloatControl, EventID.Bubble])

const SET_LOGIC = new Set<EventID>([
  EventID.SendAirBubble,
  EventID.AirBubbleMode,
  EventID.DisposeText,
  EventID.OpenUrl,
  EventID.DisableMenu,
  EventID.FreshUI,
  EventID.ReturnGameUI,
  EventID.IFEnd,
  EventID.IF,
  EventID.JumpStory,
  EventID.JumpStoryUI,
  EventID.Var,
  EventID.VarsEx,
  EventID.SeniorVar,
  EventID.Wait,
  EventID.CallSubStory,
  EventID.BackTitle,
  EventID.CallMenu,
  EventID.VitLock,
  EventID.StoryLock,
  EventID.String,
  EventID.SeniorIf,
  EventID.ForcedSaveRead,
])

const SET_EFFECT = new Set<EventID>([
  EventID.Weather,
  EventID.Shake,
  EventID.Flash,
  EventID.PlanConvertScene,
  EventID.ConvertSceneStart,
  EventID.UpateSceneHue,
  EventID.BGMAdd,
  EventID.CGAdd,
  EventID.UnlockCollect,
  EventID.SimpleEffect,
])

const SET_PIC = new Set<EventID>([
  EventID.PicShow,
  EventID.DisposePic,
  EventID.MovePic,
  EventID.MoodShow,
  EventID.RotatePic,
  EventID.ResourceLoad,
  EventID.GifPicShow,
  EventID.MaskPic,
  EventID.DressRole,
  EventID.Oaf2,
])

const SET_AUDIO = new Set<EventID>([
  EventID.StartBGM,
  EventID.StartSE,
  EventID.StartVoice,
  EventID.StartBGS,
  EventID.FadeBGM,
  EventID.StopVoice,
  EventID.StopSE,
  EventID.FadeBGS,
])

/**
 * 事件列表主文案颜色（与 docs/ue/事件颜色.md 一致）
 */
export function eventListForegroundColor(event: EventBase): string {
  const code = event.Code

  if (code === EventID.NotSelect) {
    let isText = true
    if (event instanceof EventNotSelect) {
      isText = event.IsText
    } else if (typeof (event as unknown as { IsText?: boolean }).IsText === 'boolean') {
      isText = (event as unknown as { IsText: boolean }).IsText
    }
    return isText ? C_TEXT : C_COMMENT
  }

  if (SET_TEXT.has(code)) return C_TEXT
  if (code === EventID.Comment) return C_COMMENT
  if (SET_AUTO.has(code)) return C_AUTO
  if (SET_LOGIC.has(code)) return C_LOGIC
  if (SET_EFFECT.has(code)) return C_EFFECT
  if (SET_PIC.has(code)) return C_PIC
  if (SET_AUDIO.has(code)) return C_AUDIO
  if (code === EventID.BookMark) return C_BOOKMARK

  return C_FALLBACK
}
